import React, { FC, useState } from 'react'
import ReactGA from 'react-ga'

import './styles.scss'
import { Plann3rStore } from '../../../../store/types'
import { useSelector } from 'react-redux'
import { Routes } from '../../../../routing/routes'
import { claimCompany, requestCompanyAddition } from '../../../../api/api'

const CompanyStep: FC = () => {
  const [company, setcompany] = useState('')
  const [existing, setexisting] = useState(false)
  const [thanks, setthanks] = useState(false)

  ReactGA.event({
    category: 'Onboarding',
    action: 'Step 7',
  })

  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.onboarding.companystep,
  )

  if (thanks) {
    return (
      <div className="onboarding_box">
        <div className="onboarding_content companystep">
          <h2 className="has-text-centered">{strings.thanks}</h2>
          <p>{strings.explanation}</p>
        </div>
      </div>
    )
  }
  return (
    <div className="onboarding_box">
      <div className="onboarding_content companystep">
        <h2 className="has-text-centered">
          {existing ? strings.company_name_existing : strings.company_name}
        </h2>
        <p>{existing ? strings.description_existing : strings.description}</p>
        <input
          type="text"
          placeholder="Tesla"
          value={company}
          onChange={(e) => setcompany(e.target.value)}
        />
        {!existing && <span>{strings.tip}</span>}
        {!existing && (
          <button
            className="button is-secondary"
            onClick={ async () => {
              const response = await claimCompany({ company })

              if (response.success) {
                window.location.href = Routes.PAGES_MANAGEMENT
              } else {
                alert('Something went wrong. Please try again.')
              }
            }}
          >
            {strings.make_company}
          </button>
        )}
        {existing && (
          <button
            className="button is-secondary"
            onClick={ async () => {
              const response = await requestCompanyAddition({ companyName: company })

              if (response.success) {
                setthanks(true)
              } else {
                alert('Something went wrong. Please try again.')
              }
            }}
          >
            {strings.add_to_company}
          </button>
        )}
        {!existing && (
          <button
            onClick={() => {
              setexisting(true)
            }}
          >
            {strings.existing_company}
          </button>
        )}
        {existing && (
          <button
            onClick={() => {
              setexisting(false)
            }}
          >
            {strings.make_own_company}
          </button>
        )}
      </div>
    </div>
  )
}

export default CompanyStep
